import { Grid, Typography } from '@material-ui/core';
import { CONFIG } from 'shared/config';
import { useState } from 'react';
import EditFields from '../EditFields/EditFields';
import DisplayField from '../DisplayField/DisplayField';
import CopyAndShare from '../CopyAndShare/CopyAndShare';

type FieldContentProps = {
  talent_slug: string;
  talent_country_code: string;
  changeSlug: Function;
};

const FieldContent = ({ talent_slug, talent_country_code, changeSlug }: FieldContentProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const baseUrl = `${CONFIG?.TALENT_APP_URL}/${talent_country_code?.toLowerCase() || 'not-available'}/${talent_slug}`;
  return (
    <Grid container alignItems="center" style={{ marginTop: '15px' }}>
      <Grid item xs={12} lg={6}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={10}>
            {isEditing ? (
              <EditFields
                talent_slug={talent_slug}
                talent_country_code={talent_country_code}
                isEditing={isEditing}
                seIsEditing={setIsEditing}
                changeSlug={changeSlug}
              />
            ) : (
              <DisplayField baseUrl={baseUrl} setIsEditing={setIsEditing} />
            )}
          </Grid>
          <Grid item xs={12} md={2}>
            <CopyAndShare textToCopy={baseUrl} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Typography style={{ fontSize: 11 }}>
          This is your default domain URL. You can adjust your name if it is available to use and select which profile
          below that you would like to allocate to this default domain.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default FieldContent;
